import * as React from 'react';

interface RowProps {
  onClick();
}

export class Row extends React.PureComponent<RowProps, {}> {
  render() {
    return (
      <div onClick={this.props.onClick} className='multiple-select-row'>
        {this.props.children}
      </div>
    );
  }
}
